import React from 'react';
import '../../pages/admin/remote-config.css';

export default function Toggle({ checked, onChange, size = 'default', disabled }) {
    return (
        <label className={`toggle${size === 'large' ? ' toggle--large' : ''}`}>
            <input
                type="checkbox"
                checked={!!checked}
                disabled={disabled}
                onChange={(e) => onChange?.(e.target.checked)}
            />
            <span className="toggle-slider" />
        </label>
    );
}

export function VisibilityOption({ label, desc, checked, onChange }) {
    return (
        <div className="mp-visibility-option">
            <div>
                <strong>{label}</strong>
                {desc && <p>{desc}</p>}
            </div>
            <Toggle checked={checked} onChange={onChange} />
        </div>
    );
}
